import React from "react";
import { saveAs } from "file-saver";
import PropTypes from "prop-types";
import ajiConfig from "../../ajiConfig";
import ButtonMain from "../../../../../../../../common/components/button/ButtonMain";

const DownloadTool = ({ chatMessage, isChatting, downloadIcon }) => {
  const handleDownload = () => {
    const chatHistory = chatMessage
      .map((item) => `${item.type}：${item.message}`)
      .join("\n\n");
    const blob = new Blob([chatHistory], { type: "text/plain;charset=utf-8" });
    saveAs(blob, ajiConfig.downloadFileName);
  };

  return (
    <ButtonMain
      buttonProps={{
        sx: { "&.MuiButton-root": { borderRadius: "8px" }, width: "170px" },
        text: "下載",
        fullWidth: true,
        onClick: handleDownload,
        variant: "linearGradient",
        disabled: isChatting,
        startIcon: <img src={downloadIcon} alt="downloadIcon" />,
      }}
    />
  );
};

DownloadTool.propTypes = {
  chatMessage: PropTypes.array.isRequired,
  isChatting: PropTypes.bool.isRequired,
  downloadIcon: PropTypes.string.isRequired,
};

export default DownloadTool;
